import { CheckBoxIcon } from '../../../../assets';

export const PHYSICIAN_ENGAGEMENT_CHANNELS = [
    'All',
    'E-mail',
    'Programmatic',
    'Direct Mail',
    'EHR',
    'Mobile',
    'Peer to Peer',
    'Point of Care',
];

export const BAR_CHART_LEGENDS = [
    { label: 'E-mail', icon: <CheckBoxIcon fill="#FD853A"/> },
    { label: 'Programmatic', icon: <CheckBoxIcon fill="#7A5AF8" /> },
    { label: 'Direct mail', icon: <CheckBoxIcon fill="#12B76A"/> },
    { label: 'EHR', icon: <CheckBoxIcon fill="#2E90FA"/> },
    { label: 'Mobile', icon: <CheckBoxIcon fill="#6172F3"/> },
    { label: 'Peer To Peer', icon: <CheckBoxIcon fill="#F63D68"/> },
    { label: 'Point of Care', icon: <CheckBoxIcon fill="#EE46BC"/> },
];

export const PHYSICIAN_ENGAGEMENT_SEGEMENT_CHART_OPTIONS = {
    colors: [
        '#F3DBF1',
        '#E9BEE3',
        '#DB97D2',
        '#C76EBA',
        '#AD509E',
        '#8C3F7D',
        '#733567',
        '#733567',
    ],
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
    },
    title: {
        text: null,
    },
    subtitle: {
        text: null,
    },
    exporting: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px',
        },
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        },
    },
    legend: {
        useHTML: true,
        layout: 'vertical',
        verticalAlign: 'bottom',
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px',
        },
        labelFormatter() {
            return `${this.options.name} ${this.options.y + '%'}`;
            return `<span>${
                this.options.name
            }</span> <span class="donut-chart-legend-value">${
                this.options.y + '%'
            }</span>`;
            // return `<div class="flex-row justify-space-between">
            //             <div class="donut-chart-legend-segment">${this.options.name}</div>
            //             <div class="donut-chart-legend-value">${this.options.y + '%'} </div>
            //         </div>`
        },
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false },
        },
    },
    series: [
        {
            name: 'Physician Engagement Segments',
            data: [
                {
                    name: 'Segment A',
                    y: 19.77,
                },
                {
                    name: 'Segment B',
                    y: 27,
                },
                {
                    name: 'Segment C',
                    y: 7.98,
                },
                {
                    name: 'Segment D',
                    y: 12.17,
                },
                {
                    name: 'Segment E',
                    y: 3.8,
                },
                {
                    name: 'Infectious Disease Specialist',
                    y: 4.94,
                },
                {
                    name: 'Primary HIV HCP',
                    y: 17.11,
                },
                {
                    name: 'Not Available',
                    y: 5.32,
                },
            ],
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            borderRadius: 0,
        },
    ],
};

export const CHART_OPTIONS = {
    chart: {
        toolbar: {
            show: false,
        },
    },
    colors: [
        '#FD853A',
        '#7A5AF8',
        '#12B76A',
        '#2E90FA',
        '#6172F3',
        '#F63D68',
        '#EE46BC',
    ],
    xaxis: {
        categories: ['', '', '', '', '', ''],
    },
    legend: { show: false },
    xaxis: {
        title: {
            text: 'Channels',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title',
            },
        },
        crosshairs: {
            show: false,
        },
    },
    yaxis: {
        title: {
            text: 'Total Physicians',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title',
            },
        },
    },
    tooltip: {
        enabled:false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let value = series[seriesIndex][dataPointIndex];

            return `<div class="distribution-by-yop-custom-tool-tip arrow_box"> 
                    <p class="tool-tip-series-name">${value}</p>                
                </div>`;
        },
    },
    plotOptions: {
        bar: {
            columnWidth: '80%',
            borderRadius: 2,
            dataLabels: {
                position: 'top',
            },
        },
        
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize: '12px',
        },
    },
};

export const CHART_SERIES = [
    {
        name: 'Physicians Engagement Channel',
        data: [
            { x: 'E-mail', y: 245, fillColor: '#FD853A' },
            { x: 'Programmatic', y: 423, fillColor: '#7A5AF8' },
            { x: 'Direct mail', y: 266, fillColor: '#12B76A' },
            { x: 'EHR', y: 371, fillColor: '#2E90FA' },
            { x: 'Mobile', y: 251, fillColor: '#6172F3' },
            { x: 'Peer To Peer', y: 270, fillColor: '#F63D68' },
            { x: 'Point of Care', y: 328, fillColor: '#EE46BC' },
        ],
    },
];


export const RADIAL_CHART_OPTIONS = {
    chart: {
        type: 'radialBar',
        renderTo: 'container',
	    width:'100%',
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        offsetY: 0,
		toolbar: {
			show: false
		},
    },
    grid: {
        padding: {
            bottom: -30,
            top: 0,
            left: 0,
            right: 0,
        },
    },
    colors: ['#8C3F7D'],
    plotOptions: {
        radialBar: {
            // startAngle: -90,
            // endAngle: 90,
            hollow: {
                size: '70%',
                margin: 0,
                background: 'transparent',                
            },
            track: {
                margin: 0,
                background: '#FAEDF9',
                // startAngle: -90,
                // endAngle: 90,
            },
            dataLabels: {
                show: true,
                name: {
                    show: true,
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#667085',
                    offsetY: -25,
                },
                value: {
                    show: true,
                    fontSize: '36px',
                    fontWeight: 500,
                    color: '#101828',
                    offsetY: 0,
                    // formatter: function (val) {
                    //     return 243
                    // }
                },
            },
        },
    },
    stroke: {
        lineCap: 'round',
    },
    labels: ['Engaged Physicians'],
    // responsive: [
    //     {
    //         breakpoint: 1400, 
    //         options: {
    //             plotOptions: {
    //                 radialBar: {
    //                     dataLabels: {
    //                         show: true,
    //                         name: {
    //                             fontSize: '12px',
    //                             offsetY: -20,
    //                         },
    //                         value: {
    //                             fontSize: '24px',
    //                             offsetY: -10,
    //                         },
    //                     },
    //                 },
    //             },
    //         },
    //     },
    // ],
};

export const RADIAL_CHART_SERIES = [47];

export const ONCOLOGY_DATA = [
    {
        id: 1,
        title: 'Overall Response Rate',
        count: 892,
        background: '#F9FAFB',
    },
    {
        id: 2,
        title: 'Completed',
        count: 655,
        background: '#ECFDF3',
        border: '#039855',
    },
    {
        id: 3,
        title: 'Actioned',
        count: 1339,
        background: '#F9FAFB',
    },
    {
        id: 4,
        title: 'Dismissed',
        count: 1339,
        background: '#F9FAFB',
    },
    {
        id: 5,
        title: 'Average Time to Respond (days)',
        count: 1339,
        background: '#F9FAFB',
    },
];

export const FIELD_PHYSICIAN_ENGAGEMENT = {
    colors: [ '#AD509E', '#C76EBA', '#DB97D2', '#E9BEE3', '#F3DBF1' ],
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
    },
    title: {
        text: null,
    },
    subtitle: {
        text: null,
    },
    exporting: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px',
        },
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        },
    },
    legend: {
        useHTML: true,
        layout: 'vertical',
        verticalAlign: 'bottom',
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px',
        },
        labelFormatter() {
            return `${this.options.name} ${this.options.y + '%'}`;
        },
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false },
        },
    },
    series: [
        {
            name: 'Field Engagement',
            data: [
                {
                    name: 'Overall Response Rate',
                    y: 23,
                },
                {
                    name: 'Completed',
                    y: 27,
                },
                {
                    name: 'Actioned',
                    y: 20,
                },
                {
                    name: 'Dismissed',
                    y: 12,
                },
                {
                    name: 'Average Time to Respond',
                    y: 17,
                },
            ],
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            borderRadius: 0,
        },
    ],
};
